import { call, query } from "./calls";
export const packagedApp = {
    create: (app) => call("/PackagedApp", "POST", app),
    delete: (appId) => call(`/PackagedApp/${appId}`, "DELETE"),
    update: (id, app) => call(`/PackagedApp/${id}`, "PUT", app),
    search: (q) => query(`select name, id, description, namespace, iconFileUrl from PackagedApp where name like '${q}' order by name`),
};